import { useState, useCallback } from "react"
import { fetchTeams, createTeam, updateTeam, deleteTeam } from "../api/teamsApi"

export function useTeams() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetch = useCallback(async (filters = {}) => {
    setLoading(true)
    setError(null)
    try {
      setData(await fetchTeams(filters))
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { data, loading, error, fetch }
}

function useMutation(fn) {
  const [status, setStatus] = useState("idle")

  const mutate = useCallback(async (...args) => {
    setStatus("pending")
    try {
      const result = await fn(...args)
      setStatus("success")
      return result
    } catch (err) {
      setStatus("error")
      throw err.response?.data?.errors || [err.message || "Something went wrong"]
    }
  }, [])

  return { mutate, isPending: status === "pending" }
}

export const useCreateTeam = () => useMutation(createTeam)
export const useUpdateTeam = () => useMutation((id, payload) => updateTeam(id, payload))
export const useDeleteTeam = () => useMutation(deleteTeam)
